import { call, put, takeEvery } from "redux-saga/effects";
import * as actions from "./agentsBuildsGetActions";
import platformList from "data/downloads";
import { api, getAuthHeaders, createApiHooks } from "tools/apiConfigurator";
import { getCurrentSession } from "tools/localStorage";
import { hasFeatureFlag, ffKeys } from "@p81-common/shell-core-js";
import { flattenTrackedBuilds } from "./flattenTrackedBuilds";

const ARM64_PACKAGE_TYPES = ['exeArm64', 'msiArm64'];

function* agentsBuildsGet(action) {
  try {
    const session = getCurrentSession();
    // The AgentVersionDomain endpoint scopes tracks server-side by the caller's identity,
    // so it can only serve authenticated requests - pre-login (the invitation SuccessStep)
    // there is no identity to scope by and the legacy call stays the only path, which is
    // also the flag-off path.
    const useTrackedEndpoint =
      !!session && hasFeatureFlag(ffKeys.UPDATE_AGENT_VERSION_TRACK);
    const body = yield api
        .get(useTrackedEndpoint ? "agentversion/agents/builds" : "agent-builds", {
          headers: getAuthHeaders(),
          hooks: session ? createApiHooks(true) : undefined,
        })
        .json();
    // The legacy monolith endpoint wraps its payload in a {data} envelope; the
    // AgentVersionDomain endpoint returns the tracked map bare.
    const platforms = useTrackedEndpoint ? flattenTrackedBuilds(body) : body.data;

    let result = platformList
      .map((platform) => {
        let { name, packageType } = platform;
        if (platforms[name]?.[packageType]) {
          return { ...platform, ...platforms[name][packageType] };
        }
        return platform;
      })
      .filter((platform) => {
        if (ARM64_PACKAGE_TYPES.includes(platform.packageType)) {
          return !!platform.agentCdnUrl;
        }
        if (platform.packageType === "With Mobile Protect") {
          return hasFeatureFlag(ffKeys.DOWNLOAD_PAGE_MERGED_APPLICATION);
        }
        return true;
      });

    yield put(actions.requestSuccess(result));

    if (action.resolve) {
      yield call(action.resolve, result);
    }
  } catch (error) {
    yield put(actions.requestFailure(error));

    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.AGENTS_BUILDS_GET_REQUEST, agentsBuildsGet);
}

export default saga;
